import { createApp } from 'vue'
import ComponentToast from '@/components/ComponentToast.vue'

// 创建全局toast实例
let instance
const createInstance = () => {
  if (!instance) {
    const app = document.createElement('div')
    document.body.appendChild(app)
    instance = createApp(ComponentToast).mount(app)
  }
  return instance
}

// 导出toast方法
export const toast = {
  success(message, options = {}) {
    createInstance().show(message, { ...options, type: 'success' })
  },
  error(message, options = {}) {
    createInstance().show(message, { ...options, type: 'error' })
  },
  warning(message, options = {}) {
    createInstance().show(message, { ...options, type: 'warning' })
  },
  info(message, options = {}) {
    createInstance().show(message, { ...options, type: 'info' })
  }
}

export default toast